import React from "react"
import _ from "lodash"
import { Checkbox_s } from "components/table/inputs/input-styles"

type ICheckbox = {
  rowData: {}
  field: string|string[]
  persist: Function
  disabled?: boolean
  className?: string
}

const CheckboxInput = (props: ICheckbox) => {
  let disabled = ((_.get(props, "rowData.systeminput") === "systemImmutable" && !_.includes(props.className, "system-immutable-editable")) ||
                  (_.get(props, "rowData.systeminput") === "system" && _.includes(props.className, "system-disabled")))

  return (
    <Checkbox_s
      disabled={props.disabled || disabled}
      onChange={(e) => props.persist(e.checked, props.field, props.rowData)}
      checked={_.get(props.rowData, props.field)}>
    </Checkbox_s>
  )
}

export default CheckboxInput
